import api from '../auth';
const slug = 'api/groups/';

const GroupsService = () => {
    const getGroupss = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getGroupssLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getGroups = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteGroups = (id) => {
        return api
            .delete(slug + `groups/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createGroups = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateGroups = (id, data) => {
        return api.put(slug + `groups/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyGroups = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    // syncUsersGroups
    const syncUsersGroups = (id, users) => {
        return api.post(slug + `sync/${id}/`, { users }).then((res) => res.data);
    };

    return {
        getGroupss,
        getGroupssLazy,
        getGroups,
        deleteGroups,
        createGroups,
        updateGroups,
        getOptions,
        copyGroups,
        syncUsersGroups
    };
};

export default GroupsService;
